import { Button, Empty } from '@bedrock/components';
import { ChevronLeft } from '@bedrock/icons-react';
import { useHistory } from 'react-router-dom';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PartnershipEdit from '@mpc/common/src/features/SupplierNew/PartnershipEdit';
import { useMemoizedFn } from 'ahooks';
import { isDevOrTest } from '@/utils/gray';
import './index.less';

const viewClass = 'edit-new-view';

const EditNew = () => {
  const location = useLocation();
  const history = useHistory();
  const search = new URLSearchParams(location.search);
  const oaNo = search.get('oaNo') || '';
  const headerTitle = search.get('headerTitle');

  const showTitle = useMemo(() => {
    return headerTitle === 'RFI' ? 'RFI' : '信息变更';
  }, [headerTitle]);  

 
  const goBack = useMemoizedFn(() => {
    history.goBack();
  });

  if (!oaNo) {
    return <Empty description="无效的OA单号" />;
  }

  return (
    <div className="edit-new-view">
      <div className={`${viewClass}-title`}>
        <Button type="checked-neutral" icon={<ChevronLeft />} onClick={goBack} />
        <span className={'title pl-2 fw-bold text-primary text-xl'}>{showTitle}</span>
      </div>
      <div className={`${viewClass}-body`}>
        <PartnershipEdit
          env={isDevOrTest() ? 'test' : 'prod'}
          oaNo={oaNo}
          onGoBack={goBack}
          onGoHome={goBack}
          onSubmitSuccess={goBack}
          customScrollContainer={document.querySelector('.b-eed-layout-main-content')}
        />
      </div>
    </div>
  );
};

export default EditNew;
